<template>
  <div class="text-center">
    <v-dialog v-model="opened" width="500" :activator="'parent'">
      <template #activator="{ on, attrs }">
        <slot name="activator" :on="on" :attrs="attrs">
          <a v-bind="attrs" v-on="on">{{
            $t("heading.registerPage.termsOfService")
          }}</a>
        </slot>
      </template>
      <v-card>
        <v-card-title class="">
          <h6 class="heading--text d-flex align-center">
            <v-icon
              size="20"
              class="mr-4"
              color="primary"
            >
           $configureRules
            </v-icon
            >
            <span >{{ $t("heading.registerPage.termsOfService") }}</span>
          </h6>
        </v-card-title>
        <v-card-text class="pb-2">
          <div class="well well--gray pa-4" v-html="terms">

          </div>
        </v-card-text>
        <v-card-actions class="pb-2 pt-0 d-flex justify-center">
          <v-btn class="text--gray-darken1" large text @click="opened = false">
            {{ $t("button.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    terms() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, "control-panel-upgrade")) {
        return this.$store.state.home.app.from_control_panel_registration.tos;
      }
      return this.$store.state.home.app.registration_tos;
    },
  },
};
</script>

<style src="./BasicModal.scss" lang="scss" scoped/>